// extracted by mini-css-extract-plugin
export default {"root":"FileProgress_root__vtvgb","fileName":"FileProgress_fileName__nhfl2","textContainer":"FileProgress_textContainer__2MF5T","error":"FileProgress_error__QnaHw"};